import AuthenticationStore from '../stores/AuthenticationStore';
import { handleNativeAppLogout } from './wrapperAppFunctions';

const logOut = (authenticationStore: AuthenticationStore) => {
  if ((window as any).ReactNativeWebView) {
    handleNativeAppLogout();
  }

  const promise = authenticationStore.authContext?.logout({
    logoutParams: { returnTo: window.location.origin }
  });

  promise?.then(() => {
    sessionStorage.clear();
    authenticationStore.setIsAuthenticated(false);
  });
};

export default logOut;
